import { useSelector } from 'react-redux';
import { getBreadCrumbs } from 'components/Shared/BreadCrumbs/selector';
import { hasElements, NO_ELEMENT, withCurrentPage } from 'utils';
import styles from './editorialTitle.scss';

export const EditorialTitle = () => {
  const breadcrumbs = useSelector(withCurrentPage(getBreadCrumbs));

  if (!hasElements(breadcrumbs)) return NO_ELEMENT;

  const [, ...activeBreadcrumbs] = breadcrumbs;
  const title = activeBreadcrumbs
    .map(activeBreadcrumb => activeBreadcrumb.title)
    .reverse()
    .join('\n');

  return <h1 className={styles.title}>{title}</h1>;
};
